












































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import SidebarComponent from "@/components/layout/SidebarComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import SidebarContentHeaderComponent from "@/components/layout/SidebarContentHeaderComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import RequiredMarkComponent from "@/components/common/parts/RequiredMarkComponent.vue";
import FormBoxComponent from "@/components/common/form/FormBoxComponent.vue";
import FormRowComponent from "@/components/common/form/FormRowComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import InputTextComponent from "@/components/common/parts/InputTextComponent.vue";
import SelectComponent from "@/components/common/parts/SelectComponent.vue";
import CheckboxComponent from "@/components/common/parts/CheckboxComponent.vue";
import RadioComponent from "@/components/common/parts/RadioComponent.vue";
import MultiMailComponent from "@/components/common/parts/MultiMailComponent.vue";
import ConfirmDialogComponent from "@/components/common/parts/ConfirmDialogComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import { getRoutePath } from "@/router/routes";
import {
  getUsersApi,
  storeUserApi
} from "@/typescript/api_client/emesh_api/users/users_api";
import {
  GetUserErrorResponse,
  GetUsersResponse,
  StoreUserErrorResponse
} from "@/typescript/api_client/emesh_api/users/types";
import { getCompanyApi } from "@/typescript/api_client/emesh_api/master/company_api";
import { GetCompanyResponse } from "@/typescript/api_client/emesh_api/master/types";

export {
  GetUsersResponse,
  GetUserErrorResponse,
  GetCompanyResponse,
  StoreUserErrorResponse
};

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    SidebarComponent,
    ContentComponent,
    SidebarContentHeaderComponent,
    MenubarComponent,
    FormBoxComponent,
    FormRowComponent,
    RequiredMarkComponent,
    InputTextComponent,
    ButtonComponent,
    SelectComponent,
    CheckboxComponent,
    RadioComponent,
    MultiMailComponent,
    ConfirmDialogComponent,
    FooterComponent
  }
})
export default class UsersEditPage extends Vue {
  errorMsg: string = "";
  isUserActive: boolean = false;
  isUserNotice: boolean = true;
  isAlertFilter: boolean = false;

  login_id: { [s: string]: any } = { value: "", errors: [] };
  user_name: { [s: string]: any } = { value: "", errors: [] };
  company_id: { [s: string]: any } = { value: "", errors: [] };
  company_name: { [s: string]: any } = { value: "", errors: [] };
  tel_no: { [s: string]: any } = { value: "", errors: [] };
  mailAddresses: { [s: string]: any } = { value: [], errors: [] };
  language: { [s: string]: any } = { value: "JP", errors: [] };

  user_id: number = 0;
  valid_flg: number = 1;
  notice_flg: number = 1;
  alert_filter: number = 0;
  companies: GetCompanyResponse[] = [];

  hasError: boolean = false;
  errorMessages: { [s: string]: string } = {
    required_select: "選択してください",
    required_input: "入力してください",
    number: "半角英数を入力してください",
    tel: "半角数値を入力してください",
    format: "フォーマットが違います",
    alphanumeric: "半角英数を入力してください",
    login_id_unique: "このIDは既に使用されています",
    mailaddress1_unique: "このメールアドレスは既に使用されています"
  };
  isConfirmDialogOpen: boolean = false;

  openDialog() {
    this.isConfirmDialogOpen = true;
  }

  closeConfirm() {
    this.isConfirmDialogOpen = false;
  }

  movePage() {
    // this.$router.push(
    //   getRoutePath("MasterManagementsPage", {
    //     store_id: this.$route.params.store_id
    //   })
    // );

    this.$store.commit("setSensorsTabName", {
      sensorsTabName: "ユーザー情報"
    });
    this.$router.push(
      getRoutePath("SensorsShowPage", {
        store_id: this.$route.params.store_id
      })
    );
  }

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }

  setUserName(user_name: string) {
    this.user_name.value = user_name;
  }

  setCompanyId(company_id: string) {
    this.company_id.value = company_id;
  }

  setTelNo(tel_no: string) {
    this.tel_no.value = tel_no;
  }

  setLanguage(language: string) {
    this.language.value = language;
  }

  setMail(mailAddresses: Array<string>) {
    this.mailAddresses.value = mailAddresses;
  }

  setIsUserActive(isUserActive: boolean) {
    this.isUserActive = isUserActive;
    if (isUserActive) {
      // ユーザー有効化
      this.valid_flg = 1;
    } else {
      // ユーザー無効化
      this.valid_flg = 0;
    }
  }

  setAlertFilter(alert_filter: boolean) {
    this.isAlertFilter = alert_filter;
    if (alert_filter) {
      // アラートメールを飛ばす
      this.alert_filter = 0;
    } else {
      // アラートメールを飛ばさない
      this.alert_filter = 2;
    }
  }

  setNoticeFlag(userNotice: boolean) {
    this.isUserNotice = userNotice;
    if (userNotice) {
      this.notice_flg = 1;
    } else {
      this.notice_flg = 0;
    }
  }

  save() {
    let user = {};
    user["user_id"] = this.user_id;
    user["login_id"] = this.login_id.value;
    user["user_name"] = this.user_name.value;
    user["company_id"] = this.company_id.value;
    user["company_name"] = this.company_name.value;
    user["tel_no"] = this.tel_no.value;
    if (this.mailAddresses.value[0]) {
      user["mailaddress1"] = this.mailAddresses.value[0];
    } else {
      user["mailaddress1"] = null;
    }
    if (this.mailAddresses.value[1]) {
      user["mailaddress2"] = this.mailAddresses.value[1];
    } else {
      user["mailaddress2"] = null;
    }
    if (this.mailAddresses.value[2]) {
      user["mailaddress3"] = this.mailAddresses.value[2];
    } else {
      user["mailaddress3"] = null;
    }
    user["language"] = this.language.value;
    user["valid_flg"] = this.valid_flg;
    // ユーザーが有効化されている場合は画面上の値を代入
    // ユーザーが有効化されていない場合は無効化の値を代入
    if (this.valid_flg === 1) {
      user["notice_flg"] = this.notice_flg;
      user["alert_filter"] = this.alert_filter;
    } else {
      user["notice_flg"] = 0;
      user["alert_filter"] = 2;
    }
    user["store_id"] = this.$route.params["store_id"];

    storeUserApi(user)
      .then(() => {
        // // MasterManagementsPage に戻る
        // const path = getRoutePath("MasterManagementsPage", {
        //   store_id: this.$route.params.store_id
        // });
        // this.$router.push(path);

        // SensorsShowPage に戻る
        this.$store.commit("setSensorsTabName", {
          sensorsTabName: "ユーザー情報"
        });
        this.$router.push(
          getRoutePath("SensorsShowPage", {
            store_id: this.$route.params.store_id
          })
        );
      })
      .catch(e => {
        // 2021.09.22 サーバサイドのエラーを取得してメッセージを表示する処理を追加
        // ただし、errorMessageは表示領域が用意されていないので、今回の改修では追加しない
        // 追加する場合は店舗登録などのページを参照のこと
        // this.errorMessage = "保存失敗しました。";
        for (let index = 0; index < e.errors.length; ++index) {
          if (
            e.errors[index].message.includes(
              "The same value can not be registered:"
            )
          ) {
            const item = e.errors[index].message.substring(
              e.errors[index].message.indexOf(":") + 2
            );
            switch (item) {
              case "login_id":
                this.addError("login_id", "login_id_unique");
                break;
              case "mailaddress1":
                this.addError("mailAddresses", "mailaddress1_unique");
                break;
            }
          }
        }
      });
  }

  addInput(value: string) {
    this.mailAddresses.value.push(value);
  }

  mounted() {
    getCompanyApi().then((resp: GetCompanyResponse[]) => {
      this.companies = resp;
    });

    const userId = parseInt(this.$route.params["user_id"]);
    getUsersApi(userId).then((resp: GetUsersResponse) => {
      const telRegex = /-/g;
      let respUser = resp;
      this.user_id = respUser.user_id;
      this.login_id.value = respUser.login_id;
      this.user_name.value = respUser.user_name;
      this.company_id.value = respUser.company_id;
      this.company_name.value = respUser.company_name;
      // 2021.08.24 電話番号がnullの場合を考慮
      if (respUser.tel_no == null) respUser.tel_no = "";
      this.tel_no.value = respUser.tel_no.replace(telRegex, "");

      this.mailAddresses.value.push(resp.mailaddress1);
      // 2021.08.24 メールアドレス2,3枠なくても確保
      if (resp.mailaddress2) {
        this.mailAddresses.value.push(resp.mailaddress2);
      } else {
        this.mailAddresses.value.push("");
      }
      if (resp.mailaddress3) {
        this.mailAddresses.value.push(resp.mailaddress3);
      } else {
        this.mailAddresses.value.push("");
      }

      this.language.value = respUser.language;

      this.valid_flg = respUser.valid_flg;
      this.alert_filter = respUser.alert_filter;

      if (respUser.valid_flg === 1) {
        this.isUserActive = true;
      } else {
        this.isUserActive = false;
      }

      if (respUser.alert_filter === 0) {
        this.isAlertFilter = true;
      } else {
        this.isAlertFilter = false;
      }
    });
  }

  //バリデーション
  resetError() {
    this.hasError = false;
    const formNames = [
      "login_id",
      "user_name",
      "company_id",
      "company_name",
      "tel_no",
      "language",
      "mailAddresses"
    ];
    formNames.forEach(name => {
      this[name].errors = [];
    });
  }

  addError(form, error) {
    let errors = [...this[form].errors];
    errors.push(this.errorMessages[error]);
    this[form].errors = errors;
    this.hasError = true;
  }

  isErrorForm(form) {
    return this[form].errors.length > 0;
  }

  getErrorMessages(form) {
    return this[form].errors;
  }

  submit() {
    this.resetError();
    this.validateForm();
    if (this.hasError) return;
    this.save();
  }

  validateForm() {
    if (this.user_name.value === "")
      this.addError("user_name", "required_input");
    if (this.company_id.value === "")
      this.addError("company_id", "required_select");
    if (this.login_id.value === "") this.addError("login_id", "required_input");
    if (/[^0-9A-Za-z]/.test(this.login_id.value))
      this.addError("login_id", "alphanumeric");
    if (/[^0-9]/.test(this.tel_no.value)) this.addError("tel_no", "number");
    if (!this.mailAddresses.value.some(value => value != "")) {
      this.addError("mailAddresses", "required_input");
    }
    this.mailAddresses.value.forEach(mail => {
      if (mail.length > 0 && !/.+@.+\..+/.test(mail)) {
        this.addError("mailAddresses", "format");
      }
    });
  }
}
